import { takeEvery, call, put, all } from 'redux-saga/effects';
import actions from './actions';
import { API_URL } from '../../utils/constants';
import axios from 'axios';

const rootSaga = function* () {

    yield all([
        yield takeEvery(actions.GET_ALL_USERS, getAllUsers),
        yield takeEvery(actions.GET_USER_DETAILS, GetUserDetails),
    ]);
};

//get all users
const getAllUsers = function* () {

    try {
        const result = yield call(() =>
            axios.get(
                `${API_URL}/users/list`
            )
        );
        yield put({
            type: actions.SET_ALL_USERS,
            payload: result.data
        });

    } catch (err) {
        console.log(err.response.data);
    };
};

//get all users
const GetUserDetails = function* (data) {
    const { payload } = data;
    try {

        const result = yield call(() =>
            axios.get(
                `${API_URL}/users/listbyid/${payload}`
            )
        );
        yield put({
            type: actions.SET_USER_DETAILS,
            payload: { UserDetails: result.data }
        });

    } catch (err) {
        console.log(err.response.data);
    };
};

export default rootSaga;